import { Operation, } from '@wix/ambassador-forms-v2-form/types';
import _ from 'lodash';
const validateCondition = (condition, state) => {
    if (!condition) {
        return true;
    }
    const { and, or, eq, exists, gte, lte, hasAll, hasSome, not } = condition;
    if (and) {
        return _.every(and.clauses, (clause) => validateCondition(clause, state));
    }
    if (or) {
        return _.some(or.clauses, (clause) => validateCondition(clause, state));
    }
    if (eq) {
        const fieldValue = state[eq.fieldKey];
        return fieldValue === eq.value;
    }
    if (exists) {
        const fieldValue = state[exists.fieldKey];
        return exists.exists ? !!fieldValue : !fieldValue;
    }
    if (gte) {
        const fieldValue = state[gte.fieldKey];
        return fieldValue >= gte.value;
    }
    if (lte) {
        const fieldValue = state[lte.fieldKey];
        return fieldValue <= lte.value;
    }
    if (hasAll) {
        const fieldValue = state[hasAll.fieldKey];
        return _.every(hasAll.values, (value) => _.includes(fieldValue, value));
    }
    if (hasSome) {
        const fieldValue = state[hasSome.fieldKey];
        return _.some(hasSome.values, (value) => _.includes(fieldValue, value));
    }
    if (not) {
        return !validateCondition(not.clauses, state);
    }
    return false;
};
const runAction = (action, isValid) => {
    const { operation, fieldKeys } = action;
    if (!fieldKeys) {
        return { hidden: {}, required: {} };
    }
    switch (operation) {
        case Operation.SHOW:
            return {
                hidden: fieldKeys.reduce((acc, curr) => {
                    acc[curr] = isValid ? false : true; // if wants to show state is false (state sets hidden state)
                    return acc;
                }, {}),
                required: {},
            };
        case Operation.HIDE:
            return {
                hidden: fieldKeys.reduce((acc, curr) => {
                    acc[curr] = isValid ? true : false; // if wants to hide state is true
                    return acc;
                }, {}),
                required: {},
            };
        case Operation.REQUIRED:
            return {
                required: fieldKeys.reduce((acc, curr) => {
                    acc[curr] = isValid ? true : false; // if wants to required state is true
                    return acc;
                }, {}),
                hidden: {},
            };
        case Operation.OPTIONAL:
            return {
                required: fieldKeys.reduce((acc, curr) => {
                    acc[curr] = isValid ? false : true; // if wants to set optional state is false (state sets required state)
                    return acc;
                }, {}),
                hidden: {},
            };
    }
    return { hidden: {}, required: {} };
};
const runActions = (rule, state) => {
    if (rule.enabled) {
        const isValid = validateCondition(rule.condition, state);
        return _.reduce(rule.actions, (acc, action) => {
            const result = runAction(action, isValid);
            acc.hidden = Object.assign(Object.assign({}, acc.hidden), result.hidden);
            acc.required = Object.assign(Object.assign({}, acc.required), result.required);
            return acc;
        }, { hidden: {}, required: {} });
    }
    return { hidden: {}, required: {} };
};
export const run = (rules, state) => {
    if (!rules) {
        return { hidden: {}, required: {} };
    }
    return _.reduce(rules, (acc, rule) => {
        const result = runActions(rule, state);
        acc.hidden = Object.assign(Object.assign({}, acc.hidden), result.hidden);
        acc.required = Object.assign(Object.assign({}, acc.required), result.required);
        return acc;
    }, { hidden: {}, required: {} });
};
//# sourceMappingURL=rules.js.map